import { render, staticRenderFns } from "./SurveyList.vue?vue&type=template&id=12b321d2&scoped=true"
import script from "./SurveyList.vue?vue&type=script&lang=ts"
export * from "./SurveyList.vue?vue&type=script&lang=ts"
import style0 from "./SurveyList.vue?vue&type=style&index=0&id=12b321d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b321d2",
  null
  
)

export default component.exports